/* eslint camelcase: 0 */
import api from './api';
import { NotificationReceiptSnapshot } from '../models/Notification';
import { NotificationType } from '../constants/notification';
import { getBackVersion } from '../config';

const getReceipts = (
    metadataId: string,
    notificationTypes: NotificationType[]
): Promise<NotificationReceiptSnapshot[]> =>
    api.request<NotificationReceiptSnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/notifications/receipt/${metadataId}`,
        params: {
            notification_types: notificationTypes.join(','),
        },
    });

export default { getReceipts };
